export default class PaginationController {
  /* @ngInject */
  constructor($log) {
    this.$log = $log;
  }

  $onChanges(changes) {
    // these values are always coming from outside the component
    if (changes.numberOfResults && changes.numberOfResults.currentValue) {
      this.initialisePagination();
      this.calculateResultShowing();
    }
    if (changes.currentPage) {
      this.calculateResultShowing();
    }
  }

  initialisePagination() {
    this.calculateNumberOfPages();
    // sends an event to the parent triggering the change in pageNumber
    this.updatePaginationCurrentPage({ pageNumber: 0 });
    // builds an array of numbers for each page required
    // this drives the ng-repeat in the template
    this.links = Array.from(Array(this.numberOfPages).keys());
  }

  calculateNumberOfPages() {
    if (this.numberOfResults <= this.resultsPerPage) {
      this.numberOfPages = 1;
    } else {
      this.numberOfPages =
        this.numberOfResults % this.resultsPerPage === 0 ?
          // we either have an evenly divisible number of pages
          this.numberOfResults / this.resultsPerPage :
          // or we end up with a fractional result that needs to be processed
          Math.trunc(this.numberOfResults / this.resultsPerPage) + 1;
    }
  }

  calculateResultShowing() {
    // Used to determine how the displaying indication works
    // e.g. 'Results 1-3 of 6' if there are 3 results per page
    // the resultsInCurrentPage is normally the same each time except on the last page
    // so the first part will display the currentPage + 1 ... to.. currentPage + 1 + resultsPerPage
    let resultsInCurrentPage;
    if (this.currentPage + 1 < this.numberOfPages) {
      resultsInCurrentPage = this.resultsPerPage;
    } else {
      // the last page results can be calculated in several different ways:
      // the last page can have more than 1 result but less than resultsPerPage
      const resultsOnLastPage = this.numberOfResults % this.resultsPerPage;
      if (resultsOnLastPage > 1) {
        resultsInCurrentPage = resultsOnLastPage;
      }
      // or it can have exactly the same number as resultsPerPage
      if (resultsOnLastPage === 0) {
        resultsInCurrentPage = this.resultsPerPage;
      }
      // or it can have only one result
      if (resultsOnLastPage === 1) {
        resultsInCurrentPage = 1;
      }
    }
    // we wont display a range if there is only one result on the last page
    if (resultsInCurrentPage === 1) {
      this.resultShowing = `${(this.currentPage * this.resultsPerPage) + 1} of ${this.numberOfResults}`;
    } else {
      // otherwise we will always display a range
      this.resultShowing = `${(this.currentPage * this.resultsPerPage) + 1} - ${(this.currentPage * this.resultsPerPage) + resultsInCurrentPage} of ${this.numberOfResults}`;
    }
  }

  updateCurrentPage(incrementBy) {
    this.updatePaginationCurrentPage({ pageNumber: this.currentPage + incrementBy });
  }
}



// WEBPACK FOOTER //
// ./src/components/pagination/pagination.controller.js